import PouchLoadService from "external-services/pouch-load-service/index";

/**
 * Has dependency on floorplan-bundle.js
 */

const NS = 'PlanTextOnlyService';

export default function PlanTextOnlyService(SnapConst, SnapService, PlanConst, Group, Structure) {
  "ngInject";

  function TextOnly(s, mode, model) {

    var defaults = {
      _id: PouchLoadService.getNewId(['structure']),
      type: Structure.Type,
      subType: Structure.SubTypes.TextOnly,
      position: {
        x: 0,
        y: 0
      },
      rotation: 0
    };

    this.s = s;
    this.mode = mode;
    this.model = _.extend({}, defaults, model);
    this.resizable = _.clone(TextOnly.Resizable);
    this.actions = _.clone(TextOnly.Actions);

    this.render();
    this.shape = SnapService.getShape(this.getElement());
    this.refresh();
    this.place(this.model.position);
    this.rotate(this.model.rotation);
  }

  TextOnly.prototype = _.extend({}, new Structure(), {
    render: function () {
      this.element = new Group(this.s, 'TextOnly', {
        type: SnapConst.Shapes.Rect
      });
      SnapService.getElement(this.element).addClass('structure ' + this.model.subType).data()._id = this.model._id;
      this.content = this.s.text(0, 0, this.model.content || "Text Only").addClass('label');
      this.element.addElement(this.content, 'content');
    },

    refresh: function () {
      var currRotation = this.model.rotation;
      var crot = (currRotation > 0 ? -currRotation : Math.abs(currRotation));
      var currPos = SnapService.getPosition(this.getElement());
      var rotated = false;
      if (currRotation !== 0) {
        SnapService.rotate(this.getElement(), crot, this.shape.w / 2, this.shape.h / 2);
        rotated = true;
      }
      this.content.node.innerHTML = this.model.label || "Text Only";
      var prevSize = _.clone(this.shape);
      this.shape = SnapService.getShape(this.element);
      var diff = {
        w: this.shape.w - prevSize.w,
        h: this.shape.h - prevSize.h
      };
      if (rotated) {
        SnapService.rotate(this.getElement(), currRotation, this.shape.w / 2, this.shape.h / 2);
        SnapService.place(this.getElement(), currPos.x - diff.w / 2, currPos.y - diff.h / 2);
      }
    },
  });

  /************************************************************************************************************************
   *************************************************************************************************************************
   STATIC ATTRIBUTES AND FUNCTIONS
   *************************************************************************************************************************
   ************************************************************************************************************************/

  TextOnly.Resizable = {
    hStep: 0,
    hMin: 0,
    hMax: -1,
    wStep: 0,
    wMin: 0,
    wMax: -1
  };

  TextOnly.Actions = {
    spread: false,
    rotate: true,
    edit: true
  };

  TextOnly.buildToolbarElement = function (s, type) {
    var g = new Group(s, 'TextOnly', {
      type: SnapConst.Shapes.Rect,
      w: 80,
      h: 40
    });
    g.buildRootElement();
    g.getSGroup().addClass('structure ' + type);
    g.getSGroup().data('type', type);
    var label = s.text(0, 0, Structure.getTypeName(type)).addClass('label');
    g.addElement(label, 'label');
    SnapService.place(label, 0, 20);
    return g;
  };

  return TextOnly;
}
